import { TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import {
  StyledGroupTableRow,
  StyledTable,
  StyledTableBody,
  StyledTableCell,
  StyledTableContainer,
  StyledTableHead,
  StyledTableRow,
  TitleWrapper,
} from './Table.styles';
import { TableHeadCell } from './Table.styles';
import InfoIcon from '@mui/icons-material/Info';
import { Stack } from '@mui/material/';
import { PLAN_TYPE } from '../../pages/ActionPlan/constants';
import { CustomResourcesApi } from '../../pages/ActionPlan/hooks/useCustomResources';
import { InitiativesTable } from './Initiatives/Initiatives';
import { InitiativesStatusApi } from '../../pages/ActionPlan/hooks/useInitiativesStatus';

export interface IColumn {
  id: string;
  name: string;
  width?: string;
  iconDescription?: string;
}

export interface ITableComponent {
  tableName?: string;
  rows: Record<string, unknown>[];
  columns: IColumn[];
  isHead?: boolean;
  dataTestId?: string;
  isPreviewMode?: boolean;
  isCompleted?: boolean;
  customResourcesData?: {
    planTypeId: keyof typeof PLAN_TYPE;
    customResourcesApi: CustomResourcesApi;
    onCheckboxClick: (id: string, tabId: string) => void;
    selectedItems: Record<string, string[]>;
  };
  initiativesStatusData?: {
    initiativesStatusApi: InitiativesStatusApi;
  };
}

export const TableComponent = ({
  tableName,
  rows,
  columns,
  isHead = true,
  dataTestId,
  customResourcesData,
  initiativesStatusData,
  isPreviewMode,
  isCompleted,
}: ITableComponent) => {
  return (
    <>
      {tableName && (
        <TitleWrapper>
          <Typography variant="h6" textTransform="capitalize">
            {tableName}
          </Typography>
        </TitleWrapper>
      )}
      <StyledTableContainer data-testid={dataTestId || tableName}>
        <StyledTable>
          {isHead && (
            <StyledTableHead>
              <TableRow>
                {columns?.map((cell) => (
                  <TableHeadCell
                    key={cell.id}
                    width={cell.width}
                    styledBgColor={columns.length > 4 && cell.id === 'globalBenchmarkKpi'}
                  >
                    <Stack>
                      {cell.name}
                      {cell.iconDescription && (
                        <Tooltip title={cell.iconDescription} arrow placement={'top'}>
                          <InfoIcon />
                        </Tooltip>
                      )}
                    </Stack>
                  </TableHeadCell>
                ))}
              </TableRow>
            </StyledTableHead>
          )}
          {dataTestId === 'initiatives-table' ? (
            <InitiativesTable
              rows={rows}
              columns={columns}
              customResourcesData={customResourcesData}
              initiativesStatusData={initiativesStatusData}
              isPreviewMode={isPreviewMode}
              isCompleted={isCompleted}
            />
          ) : (
            <StyledTableBody>
              {rows?.map((row) => {
                return row.groupRow ? (
                  <StyledGroupTableRow key={row.id as string}>
                    <TableCell colSpan={5}>{row.title as string}</TableCell>
                  </StyledGroupTableRow>
                ) : (
                  <StyledTableRow
                    key={(row.id || row.kpi) as string}
                    backgroundColor={(row.backgroundColor as string) || undefined}
                  >
                    {columns.map((cell) => (
                      <StyledTableCell
                        key={row.id + cell.id}
                        component="th"
                        scope="row"
                        styledBgColor={!!row.intlBenchmarkKpi && cell.id === 'globalBenchmarkKpi'}
                      >
                        {row[cell.id] as string}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                );
              })}
            </StyledTableBody>
          )}
        </StyledTable>
      </StyledTableContainer>
    </>
  );
};
